import { StyledMarkdownContainer } from '@shared/components/core/text/MarkdownTypography';
import 'property-information'; // This is a hack to get the markdown to render correctly during development SEE: https://github.com/parcel-bundler/parcel/discussions/9113
import Markdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

export interface IResourceMarkdownProps {
    markdown: string;
}

export default function ResourceMarkdown({ markdown }: IResourceMarkdownProps) {
    return (
        <StyledMarkdownContainer>
            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
                {markdown}
            </Markdown>
        </StyledMarkdownContainer>
    );
}
